import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { href: "/your/dashboard" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["href"]
const _hoisted_4 = ["href"]
const _hoisted_5 = { href: "/account/todo" }
const _hoisted_6 = { href: "/account/notification" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { href: "/conversations" }
const _hoisted_10 = { key: 0 }

import { onMounted } from 'vue';
import { omitWithCap } from '@/js/lib/helper/number';
import { dynamicImageUrl } from '@/js/lib/helper/url';
import { credentials } from '@/js/lib/api/user';
import { useCommonStore } from '@/js/lib/store/common';
import { useMessageStore } from '@/js/lib/store/message';
import { useNotificationStore } from '@/js/lib/store/notification';
import { useShopStore } from '@/js/lib/store/shop';
import { useTimelineStore } from '@/js/lib/store/timeline';
import { useTodoStore } from '@/js/lib/store/todo';
import { useUserStore } from '@/js/lib/store/user';
import ShopStatusVacation from '@/js/components/organisms/ShopStatusVacation.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderAccount',
  setup(__props) {

const commonStore = useCommonStore();
const userStore = useUserStore();
const shopStore = useShopStore();
const notificationStore = useNotificationStore();
const todoStore = useTodoStore();
const messageStore = useMessageStore();
const timelineStore = useTimelineStore();
const isPreSeller = userStore.hasCredential(credentials.preSeller);
const isPromoter = userStore.hasCredential(credentials.promoter);
const isSeller = userStore.hasCredential(credentials.seller);

onMounted(() => {
  if (userStore.isAuthenticated) {
    if (isPreSeller) {
      notificationStore.checkUpdated();
      todoStore.loadTodos();
    }
    messageStore.checkUnreadCount();
    timelineStore.checkItemUpdated();
    timelineStore.checkEventUpdated();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.$style.account, _unref(commonStore).isWebView && _ctx.$style.webview])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.accountName)
    }, [
      _createElementVNode("a", _hoisted_1, [
        (_unref(userStore).picturePath)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _unref(dynamicImageUrl)(_unref(userStore).picturePath, 100, 100),
              width: "50",
              height: "50",
              alt: ""
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        _cache[1] || (_cache[1] = _createTextVNode()),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style.accountNameText)
        }, [
          _createElementVNode("p", {
            class: _normalizeClass(_ctx.$style.name)
          }, _toDisplayString(_unref(userStore).memberName), 3),
          _cache[0] || (_cache[0] = _createTextVNode()),
          (_unref(isSeller) && _unref(shopStore).isOnVacation)
            ? (_openBlock(), _createBlock(ShopStatusVacation, { key: 0 }))
            : (_openBlock(), _createElementBlock("p", {
                key: 1,
                class: _normalizeClass(_ctx.$style.dashboard)
              }, "マイページ", 2))
        ], 2)
      ])
    ], 2),
    _cache[20] || (_cache[20] = _createTextVNode()),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.accountMenu)
    }, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          (_unref(isSeller))
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: `/shop/${_unref(userStore).aliasOrSlug}`
              }, "ショップを見る", 8, _hoisted_3))
            : (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: `/people/${_unref(userStore).aliasOrSlug}`
              }, "プロフィールを見る", 8, _hoisted_4))
        ]),
        _cache[5] || (_cache[5] = _createTextVNode()),
        (_unref(isPreSeller))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_5, [
                  _cache[2] || (_cache[2] = _createTextVNode("やることリスト")),
                  (_unref(todoStore).totalCount > 0)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(_ctx.$style.updated)
                      }, _toDisplayString(_unref(omitWithCap)(_unref(todoStore).totalCount)), 3))
                    : _createCommentVNode("", true)
                ])
              ]),
              _cache[4] || (_cache[4] = _createTextVNode()),
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_6, [
                  _cache[3] || (_cache[3] = _createTextVNode("お知らせ")),
                  (_unref(notificationStore).updatedCount > 0)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(_ctx.$style.updated)
                      }, _toDisplayString(_unref(omitWithCap)(_unref(notificationStore).updatedCount)), 3))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _cache[16] || (_cache[16] = _createTextVNode()),
      (_unref(isSeller))
        ? (_openBlock(), _createElementBlock("ul", _hoisted_7, _cache[6] || (_cache[6] = [
            _createStaticVNode("<li><a href=\"/your/item/create\">作品登録</a></li> <li><a href=\"/your/items\">作品管理</a></li> <li><a href=\"/your/orders\">受注管理</a></li> <li><a href=\"/your/analysis\">アクセス解析</a></li> <li><a href=\"/your/sales\">売上・入金</a></li>", 9)
          ])))
        : _createCommentVNode("", true),
      _cache[17] || (_cache[17] = _createTextVNode()),
      (_unref(isPromoter))
        ? (_openBlock(), _createElementBlock("ul", _hoisted_8, _cache[7] || (_cache[7] = [
            _createElementVNode("li", null, [
              _createElementVNode("a", { href: "/your/event/create" }, "イベント登録")
            ], -1),
            _createTextVNode(),
            _createElementVNode("li", null, [
              _createElementVNode("a", { href: "/your/events" }, "イベント管理")
            ], -1)
          ])))
        : _createCommentVNode("", true),
      _cache[18] || (_cache[18] = _createTextVNode()),
      _createElementVNode("ul", null, [
        _cache[9] || (_cache[9] = _createElementVNode("li", null, [
          _createElementVNode("a", { href: "/your/purchases" }, "購入履歴")
        ], -1)),
        _cache[10] || (_cache[10] = _createTextVNode()),
        _createElementVNode("li", null, [
          _createElementVNode("a", _hoisted_9, [
            _cache[8] || (_cache[8] = _createTextVNode("メッセージ")),
            (_unref(messageStore).unreadCount > 0)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(_ctx.$style.updated)
                }, _toDisplayString(_unref(omitWithCap)(_unref(messageStore).unreadCount)), 3))
              : _createCommentVNode("", true)
          ])
        ]),
        _cache[11] || (_cache[11] = _createTextVNode()),
        _cache[12] || (_cache[12] = _createElementVNode("li", null, [
          _createElementVNode("a", { href: "/your/settings" }, "設定")
        ], -1))
      ]),
      _cache[19] || (_cache[19] = _createTextVNode()),
      _createElementVNode("ul", null, [
        (_unref(commonStore).isWebView)
          ? (_openBlock(), _createElementBlock("li", _hoisted_10, _cache[13] || (_cache[13] = [
              _createElementVNode("a", { href: "https://help.iichi.com/hc/ja/" }, "ヘルプ", -1)
            ])))
          : _createCommentVNode("", true),
        _cache[14] || (_cache[14] = _createTextVNode()),
        _cache[15] || (_cache[15] = _createElementVNode("li", null, [
          _createElementVNode("a", { href: "/signout" }, "ログアウト")
        ], -1))
      ])
    ], 2)
  ], 2))
}
}

})